import { getMobileAndDesktopFirstImage } from 'components/PageSections/utils';

import { WelcomePageProps } from './WelcomeToMembership';

export function parseWelcomeToMembership(
  section: Queries.ContentfulSection001,
): WelcomePageProps {
  const { metadata, images } = section || {};

  const sectionImages = getMobileAndDesktopFirstImage(images);

  return {
    description: {
      raw: section?.body?.raw || '',
    },
    heading: metadata?.title || '',
    cta: metadata?.ctas?.[0] || null,
    mobileImage: sectionImages.mobileImage,
    desktopImage: sectionImages.desktopImage,
  };
}
